module.exports = __webpack_public_path__ + "static/media/cowbell-more.66027018.svg";